/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CardContent } from '../../models/card-content';

export interface ApiMasterCardContentGetByIdGet$Params {
  id?: string;
}

export function apiMasterCardContentGetByIdGet(http: HttpClient, rootUrl: string, params?: ApiMasterCardContentGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CardContent>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCardContentGetByIdGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CardContent>;
    })
  );
}

apiMasterCardContentGetByIdGet.PATH = '/api/Master/CardContent/GetById';
